import CheckIcon from '@mui/icons-material/Check';
import ErrorIcon from '@mui/icons-material/Error';
import SaveIcon from '@mui/icons-material/Save';
import { Box, CircularProgress } from '@mui/material';
import Button from '@mui/material/Button';
import { green, red } from '@mui/material/colors';
import Fab from '@mui/material/Fab';
import makeStyles from '@mui/styles/makeStyles';
import { styled } from '@mui/system';
import clsx from 'clsx';
import React from 'react';

const useStyles = makeStyles(theme => ({
    buttonSuccess: {
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    buttonFailed: {
        backgroundColor: red[500],
        '&:hover': {
            backgroundColor: red[700],
        },
    },
}));

const CircularProgress1 = styled(CircularProgress)(({ theme }) => ({
    color: green[500],
    position: 'absolute',
    top: 4,
    left: 4,
    zIndex: 1,
}));

const FollowFab = styled(Fab)(({ theme }) => ({
    position: 'absolute',
    top: 2,
    left: 2,
}));

const CircularProgress2 = styled(CircularProgress)(({ theme }) => ({
    color: green[500],
    position: 'absolute',
    top: '35%',
    left: '50%',
    marginTop: -1.5,
    marginLeft: 3,
    [theme.breakpoints.only('xs')]: {
        top: '22%',
        left: '60%',
    },
}));

const SizeBox = styled(Box)(({ theme }) => ({
    position: 'relative',
    height: '80px',
    [theme.breakpoints.down('sm')]: {
        height: '140px',
    },
}));

const ContainerBox = styled(Box)(({ theme }) => ({
    width: '280px',
    [theme.breakpoints.only('xs')]: {
        width: '200px',
    },
}));

const FollowButton = styled(Button)(({ theme }) => ({
    position: 'absolute',
    top: 20,
    left: 80,
    bgcolor: green[500],
    '&:hover': {
        bgcolor: green[700],
    },
    [theme.breakpoints.only('xs')]: {
        top: 8,
    },
}));

export default function CircularIntegration(props) {
    //Pass in the following props success, failed, failedMessage, successMessage, loading
    const classes = useStyles();

    const buttonSx = {
        margin: 1,
        ...(props.success && {
            bgcolor: green[500],
            '&:hover': {
                bgcolor: green[700],
            },
        }),
    };

    const buttonClassname = clsx({
        [classes.buttonSuccess]: props.success,
        [classes.buttonFailed]: props.failed,
    });

    return (
        <ContainerBox>
            <SizeBox>
                <FollowFab
                    aria-label="save"
                    color="primary"
                    sx={buttonSx}
                    className={buttonClassname}
                >
                    {props.success ? (
                        <CheckIcon />
                    ) : (
                        <div>{props.failed ? <ErrorIcon /> : <SaveIcon />}</div>
                    )}
                </FollowFab>
                {props.loading && <CircularProgress1 size={68} />}
                <FollowButton
                    variant="contained"
                    color="primary"
                    className={buttonClassname}
                    disabled={props.loading}
                >
                    {props.failed ? props.failedMessage : props.successMessage}
                </FollowButton>
                {props.loading && <CircularProgress2 size={24} />}
            </SizeBox>
        </ContainerBox>
    );
}
